import React from "react";
import Dashboard from "./Dashboard";
import AdminOneDashboard from "./AdminOneDashboard";

export const DashboardApp = () => {
  if (site.permissions.canAccessAdminOne) {
    return <AdminOneDashboard />
  }

  return <Dashboard />
}